import { render, staticRenderFns } from "./search-filter.vue?vue&type=template&id=2b128092&scoped=true&"
import script from "./search-filter.vue?vue&type=script&lang=js&"
export * from "./search-filter.vue?vue&type=script&lang=js&"
import style0 from "./search-filter.vue?vue&type=style&index=0&id=2b128092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b128092",
  null
  
)

export default component.exports